import React from "react";
import { Divider, Form, Grid, Header } from "semantic-ui-react";
import InsuranceAttachments from "../Attachments/InsuranceAttachments";
import PurchaseInfoForm from "../../../../../components/Forms/PurchaseInfoForm";
import Insurance from "../Insurance";
import PurchaseAttachments from "../Attachments/PurchaseAttachments";
import ValuationInfoForm from "../../../../../components/Forms/ValuationInfoForm";

const Financial = ({ piece, onUpdate }) => {
  const onSelectGallery = (gallery) => onUpdate({ gallery });
  const handleChange = (e, { name, value }) => onUpdate({ [name]: value });

  return (
    <Grid>
      <Grid.Row columns={1}>
        <Grid.Column>
          <PurchaseInfoForm
            piece={piece}
            handleChange={handleChange}
            onUpdate={onUpdate}
          />
        </Grid.Column>
      </Grid.Row>
      <Divider />
      <Grid.Row columns={1}>
        <Grid.Column>
          <ValuationInfoForm
            piece={piece}
            handleChange={handleChange}
            onUpdate={onUpdate}
          />
        </Grid.Column>
      </Grid.Row>
      <Divider />
      <Grid.Row columns={1}>
        <Grid.Column>
          <Insurance piece={piece} onUpdate={onUpdate} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default Financial;
